import { Form } from "react-bootstrap";
import { orderAtom } from "../atoms/atoms";
import { useSetAtom } from "jotai";
import { useState } from "react";

const TermsSwitch = () => {

    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const setOrder = useSetAtom(orderAtom);

    const onAcceptTermsChange = (e) => {
        setAcceptedTerms(e.target.checked);
        setOrder((prev) => ({
            ...prev,
            acceptedTerms: e.target.checked,
        }));
    }

    return(
        <Form.Check // prettier-ignore
        className="mt-5"
        type="switch"
        id="terms-switch"
        label="Przeczytałem/am i akceptuję regulamin oraz politykę prywatności."
        onChange={(e) => {
            onAcceptTermsChange(e);
        }}
    />
    )
}

export default TermsSwitch;